import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getHandSanitizer(condition = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/HandSanitizerDetector`)
    response.data = await response.data.map(Utils.handleDeviceLntLng)//將洗手乳資料的經緯度洗成center:[lat,long]
    
    
  } catch (err) {
    console.error('iisi getHandSanitizer: ', err)
    return null
  }
  
 
  return response.data
}